import React from "react";


export const StoreMetaDataContext = React.createContext({
    storeMeta: [],
    isLoading: true,
})